import "./TestimonialCard.scss";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

export default function TestimonialCard({
    avatar,
    customerName,
    rating,
    comments,
    testimonySource,
    readOn
}) {
    // Create initials if avatar is missing
    const getInitials = (n) =>
        n
            .split(" ")
            .map((w) => w[0])
            .join("")
            .toUpperCase();

    // Generate star icons based on rating
    const renderStars = (ratingValue) => {
        const stars = [];
        const full = Math.floor(ratingValue);
        const half = ratingValue % 1 !== 0;

        for (let i = 0; i < full; i++) {
            stars.push(<FaStar key={`full-${i}`} />);
        }

        if (half) {
            stars.push(<FaStarHalfAlt key="half" />);
        }

        while (stars.length < 5) {
            stars.push(<FaRegStar key={`empty-${stars.length}`} />);
        }

        return stars;
    };

    return (
        <div className="testimonial-card">

            {/* Rating stars */}
            <div className="stars">
                {renderStars(rating)}
            </div>

            {/* Testimony text */}
            <p className="text">“{comments}”</p>

            {/* Author block */}
            <div className="author-block">
                {avatar ? (
                    <img src={`${process.env.REACT_APP_BASE_URL}/avatar/${avatar}`} alt={customerName} className="author-avatar" />
                ) : (
                    <div className="author-avatar initials">
                        {getInitials(customerName)}
                    </div>
                )}

                <div className="author-info">
                    <p className="author-name">{customerName}</p>

                    <a
                        href={readOn}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="read-source"
                    >
                        Read on <strong>{testimonySource}</strong>
                    </a>
                </div>
            </div>

        </div>
    );
}
